import React, { Component } from 'react'
import '../../../../css/Employer/Content.css'

interface IAboutProps {
    title: string,
    paragraphs: any
}

export default class AboutSection extends Component<IAboutProps, {}> {
    render() {
        return (
            <div>
                {
                    this.props.title && (
                        <h1 className="py-1">{this.props.title}</h1>
                    )
                }
                <div className="container">
                    {
                        this.props.paragraphs.map((para : any, key : number) => (
                            <p className="para font-thin" key={key}>{para.content}</p>
                        ))
                    }
                </div>
            </div>
        )
    }
}